<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex justify-content-between align-items-center px-3">
              <h6 class="text-white text-capitalize mb-0">학생(아동) 종합정보</h6>
              <div class="d-flex align-items-center">
                <select v-model="filters.department" @change="onDepartmentChange" class="form-select searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;" >
                  <option value="">부서 선택</option>
                  <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.name }}</option>
                </select>
                <select v-model="filters.grade" @change="fetchData" class="form-select searchInput me-2" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                  <option value="">반</option>
                  <option v-for="group in grades" :key="group.id" :value="group.id">{{ group.name }}</option>
                </select>
                <input v-model="filters.name" @keyup.enter="fetchData" type="text" class="form-control searchInput me-2" placeholder="이름 검색" style="width: 160px;" />
                <button class="btn btn-light text-success me-2" @click="fetchData">검색</button>
                <button class="btn btn-light text-success me-2" @click="exportToExcel" :disabled="rows.length === 0">엑셀 다운로드</button>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0 studentsummary-table">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2" style="font-size: 1rem;">부서명</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 text-center" style="font-size: 1rem;">학년</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2 text-center" style="font-size: 1rem;">사진</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2" style="font-size: 1rem;">이름</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2" style="font-size: 1rem;">선생님</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2 text-center" style="font-size: 1rem;">상세</th>
                    <th class="text-uppercase text-secondary font-weight-bolder opacity-7 ps-2 text-center" style="font-size: 1rem;">수정</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="7" class="text-center">데이터가 없습니다</td>
                  </tr>
                  <tr v-for="(row, idx) in rows" :key="idx">
                    <td>
                      <p class="cell-text">{{ row.class_name }}</p>
                    </td>
                    <td class="text-center">
                      <p class="cell-text">{{ displayGrade(row) }}</p>
                    </td>
                    <td class="text-center">
                      <img :src="imageSrc(row)" class="avatar avatar-sm" alt="photo" />
                    </td>
                    <td class="name-cell">
                      <p class="cell-text name">{{ row.name }}</p>
                    </td>
                    <td>
                      <p class="cell-text">{{ row.teacher_name }}</p>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-outline-success btn-sm action-btn" @click="openDetail(row)">보기</button>
                    </td>
                    <td class="text-center">
                      <p class="cell-text">{{ row.updated_at }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination d-flex justify-content-center mt-4" v-if="totalPages > 0">
              <ul class="pagination">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchPage(currentPage - 1)">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                  <a class="page-link" href="#" @click.prevent="fetchPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchPage(currentPage + 1)">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 상세 모달 -->
    <div v-if="showDetail" class="popup-overlay" @click.self="closeDetail">
      <div class="popup-content">
        <h6 class="mb-3">학생(아동) 종합정보</h6>
        <div class="detail-grid">
          <div><strong>특기/취미</strong></div><div>{{ detail.hobby || '-' }}</div>
          <div><strong>친한친구</strong></div><div>{{ detail.bestfriend || '-' }}</div>
          <div><strong>주의사항</strong></div><div class="preline">{{ detail.caution || '-' }}</div>
          <div><strong>예배출석</strong></div><div>{{ detail.worship_attendance || '-' }}</div>
          <div><strong>분반참여도</strong></div><div>{{ detail.class_participation || '-' }}</div>
          <div><strong>가정환경</strong></div><div class="preline">{{ detail.home_env || '-' }}</div>
          <div><strong>학생특징</strong></div><div class="preline">{{ detail.student_characteristics || '-' }}</div>
          <div><strong>종합적 소견</strong></div><div class="preline">{{ detail.overall_opinion || '-' }}</div>
          <div><strong>작성</strong></div><div>{{ detail.created_at || '-' }}</div>
          <div><strong>수정</strong></div><div>{{ detail.updated_at || '-' }}</div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-success" @click="closeDetail">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiservice from "@/services/apiservice";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  name: "StudentSummary",
  data() {
    return {
      rows: [],
      filters: { department: '', grade: '', name: '' },
      departments: [],
      grades: [],
      showDetail: false,
      detail: {},
      currentPage: 1,
      totalPages: 1,
      totalRows: 0,
      pageSize: 10
    };
  },
  methods: {
    imageSrc(row) {
      if (row.photo) return `https://manna.dongan1718.com/upload/photo/${row.photo}`;
      if (row.photo2) return `https://manna.dongan1718.com/upload/photo/${row.photo2}`;
      return require('@/assets/img/noimage.png');
    },
    displayGrade(row) {
      if (row.gradename) return row.gradename;
      const g = String(row.grade || '');
      if (g.length === 2) {
        return `${g[0]}학년${g[1]}반`;
      }
      return row.grade;
    },
    async onDepartmentChange() {
      if (!this.filters.department) { this.grades = []; this.filters.grade=''; await this.fetchData(); return; }
      try {
        const response = await apiservice.getclasslist({ classid: this.filters.department });
        if (response && response.data && response.data.data) {
          this.grades = response.data.data.map(grade => ({ id: grade.grade, name: grade.gradename }));
          this.filters.grade = '';
        } else {
          this.grades = [];
        }
      } catch (e) { this.grades = []; }
      this.fetchData();
    },
    async fetchData() {
      try {
        const payload = { ...this.filters, page: this.currentPage, limit: this.pageSize };
        const response = await apiservice.getstudentsummary(payload);
        if (response.data && response.data.success) {
          this.rows = response.data.data || [];
          this.currentPage = parseInt(response.data.currentPage || this.currentPage);
          this.totalPages = parseInt(response.data.totalPages || 1);
          this.totalRows = parseInt(response.data.totalRows || 0);
        } else {
          this.rows = [];
          this.totalPages = 1;
          this.currentPage = 1;
          this.totalRows = 0;
        }
      } catch (e) {
        this.rows = [];
        this.totalPages = 1;
        this.currentPage = 1;
        this.totalRows = 0;
      }
    },
    fetchPage(page) {
      page = parseInt(page);
      if (isNaN(page) || page < 1) page = 1;
      if (page > this.totalPages) page = this.totalPages;
      this.currentPage = page;
      this.fetchData();
    },
    async exportToExcel() {
      // 1) exportAll을 시도하고, 2) 미지원이면 페이지별로 모두 수집
      let allData = [];
      try {
        const firstPayload = { ...this.filters, exportAll: true, page: 1, limit: this.pageSize };
        const firstRes = await apiservice.getstudentsummary(firstPayload);
        const firstRows = (firstRes.data && firstRes.data.data) ? firstRes.data.data : [];
        const totalRows = parseInt(firstRes.data?.totalRows || this.totalRows || 0);
        const totalPages = parseInt(firstRes.data?.totalPages || this.totalPages || 1);

        if (totalRows > firstRows.length && totalPages > 1) {
          const requests = [];
          for (let p = 2; p <= totalPages; p++) {
            requests.push(apiservice.getstudentsummary({ ...this.filters, page: p, limit: this.pageSize }));
          }
          const results = await Promise.all(requests);
          const otherRows = results.flatMap(r => (r.data && r.data.data) ? r.data.data : []);
          allData = [...firstRows, ...otherRows];
        } else {
          allData = firstRows;
        }
      } catch (e) {
        allData = this.rows || [];
      }

      const header = ['학년', '이름', '부서명', '선생님', '특기/취미', '친한친구', '주의사항', '예배출석', '분반참여도', '가정환경', '학생특징', '종합적 소견', '작성', '수정'];
      const rows = allData.map(r => [
        this.displayGrade(r),
        r.name || '',
        r.class_name || '',
        r.teacher_name || '',
        r.hobby || '',
        r.bestfriend || '',
        r.caution || '',
        r.worship_attendance || '',
        r.class_participation || '',
        r.home_env || '',
        r.student_characteristics || '',
        r.overall_opinion || '',
        r.created_at || '',
        r.updated_at || ''
      ]);
      const aoa = [header, ...rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '학생(아동) 종합정보');
      const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const currentDate = new Date().toISOString().split('T')[0];
      saveAs(blob, `학생(아동)_종합정보_${currentDate}.xlsx`);
    },
    openDetail(row) {
      // rows already contains the extra fields from API
      this.detail = { ...row };
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.detail = {};
    }
  },
  computed: {
    isSuperUser() { return this.$store.state.userData?.superuser === '1'; },
    displayedPages() {
      const pages = [];
      const maxVisiblePages = 5;
      if (this.totalPages <= maxVisiblePages) {
        for (let i = 1; i <= this.totalPages; i++) pages.push(i);
      } else {
        let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = startPage + maxVisiblePages - 1;
        if (endPage > this.totalPages) { endPage = this.totalPages; startPage = Math.max(1, endPage - maxVisiblePages + 1); }
        for (let i = startPage; i <= endPage; i++) pages.push(i);
      }
      return pages;
    }
  },
  async mounted() {
    try {
      const deptRes = await apiservice.getdeptlist();
      this.departments = deptRes.data.data.map(d => ({ id: d.code, name: d.codename }));
      const user = this.$store.state.userData;
      if (user && user.superuser !== '1') {
        this.filters.department = user.classid;
        await this.onDepartmentChange();
      } else {
        this.fetchData();
      }
    } catch {
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.studentsummary-table th,
.studentsummary-table td {
  padding: 14px 18px;
  vertical-align: middle;
  font-size: 1rem; /* bigger */
}
.studentsummary-table thead th {
  letter-spacing: .02em;
}
.cell-text { margin: 0; line-height: 1.25; }
.name-cell .name { font-weight: 600; }
.avatar-rounded { border-radius: 8px; }
.avatar-sm {
  width: 48px;
  height: 48px;
}
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.popup-content {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  width: 720px;
  max-width: 95vw;
  max-height: 85vh;
  overflow: auto;
}
.detail-grid {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 8px 16px;
}
.preline { white-space: pre-line; }
</style>


